import { createGlobalStyle } from 'styled-components';
import bootstrapIconsFont from 'bootstrap-icons/font/fonts/bootstrap-icons.woff2';

export const GlobalStyles = createGlobalStyle`
  @font-face {
    font-display: swap;
    font-family: 'bootstrap-icons';
    src: url(${bootstrapIconsFont}) format('woff2');
  }

  /* Lenis smooth scroll rules */
  html { scroll-behavior: smooth; }
  html.lenis { height: auto; }
  .lenis.lenis-scrolling { scroll-behavior: auto !important; }
  .lenis.lenis-stopped { overflow: hidden; }

  /* Base Reset */
  *, *::before, *::after { 
    box-sizing: border-box; 
    margin: 0; 
    padding: 0; 
  }

  html {
    background-color: ${props => props.theme.colors.bgDark};
  }

  body {
    margin: 0;
    font-family: ${props => props.theme.fonts.body};
    color: ${props => props.theme.colors.white};
    line-height: 1.6;
    overflow-x: hidden;
    background-color: ${props => props.theme.colors.bgDark};
  }

  /* Dot-matrix display type for headings/brand. Per-character fallback covers
     scripts Doto cannot render; each supported script keeps its dedicated stack. */
  h1, h2 {
    font-family: ${props => props.theme.fonts.display};
    font-weight: 400;
    letter-spacing: 0.05em;
  }

  html[lang="ar"] h1, html[lang="ar"] h2 {
    font-family: ${props => props.theme.fonts.locales.ar.headings};
  }

  html[lang="ja"] h1, html[lang="ja"] h2 {
    font-family: ${props => props.theme.fonts.locales.ja.headings};
  }

  html[lang="zh"] h1, html[lang="zh"] h2 {
    font-family: ${props => props.theme.fonts.locales.zh.headings};
  }

  html[lang="hi"] h1, html[lang="hi"] h2 {
    font-family: ${props => props.theme.fonts.locales.hi.headings};
  }

  img, video, canvas, svg {
    max-width: 100%;
  }

  button, input, textarea, select {
    font: inherit;
  }

  h1, h2, h3, h4, p, a, li, span {
    overflow-wrap: anywhere;
  }

  main [id$="-section"] {
    scroll-margin-top: 80px;
  }

  /* Language Specific Fonts */
  html[lang="ar"] body {
    font-family: ${props => props.theme.fonts.locales.ar.body};
  }

  html[lang="ja"] body {
    font-family: ${props => props.theme.fonts.locales.ja.body};
  }
  
  html[lang="zh"] body {
    font-family: ${props => props.theme.fonts.locales.zh.body};
  }

  html[lang="hi"] body {
    font-family: ${props => props.theme.fonts.locales.hi.body};
  }

  /* Helper Classes */
  body.mobile-menu-open {
    overflow: hidden;
  }

  /* Animations */
  @keyframes fadeIn { 
    from { opacity: 0; transform: translateY(15px); } 
    to { opacity: 1; transform: translateY(0); } 
  }
  
  @keyframes float { 
    0%, 100% { transform: translateY(0); } 
    50% { transform: translateY(-15px); } 
  }
  
  @keyframes fadeInScaleUp { 
    from { opacity: 0; transform: translateY(30px) scale(0.95); } 
    to { opacity: 1; transform: translateY(0) scale(1); } 
  }

  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  /* Layout Utilities from App.css that might be used globally */
  .page-wrapper { position: relative; z-index: 1; }

  /* Accessibility helpers */
  .visually-hidden {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
  }

  .skip-link {
    position: absolute;
    top: -100px;
    left: 1rem;
    z-index: 2000;
    background: ${props => props.theme.colors.primary};
    color: ${props => props.theme.colors.white};
    padding: 0.75rem 1.25rem;
    border-radius: 8px;
    text-decoration: none;
    font-weight: 600;
    transition: top calc(0.2s * var(--motion-duration-scale, 1)) ease;
  }

  .skip-link:focus-visible {
    top: 1rem;
  }

  :focus-visible {
    outline: 2px solid ${props => props.theme.colors.primary};
    outline-offset: 2px;
  }

  :root {
    --motion-duration-scale: 1;
  }

  @media (prefers-reduced-motion: reduce) {
    :root {
      --motion-duration-scale: 1.5;
    }
  }
  
  .background { 
    position: fixed; 
    top: 0; 
    left: 0; 
    width: 100%; 
    height: 100%; 
    z-index: -1; 
  }

  /* WebGL background canvas: fill the fixed BackgroundWrapper exactly like
     the snow overlay. Without this the canvas falls back to inline display
     sized by its pixel attributes, which is fragile across resizes, DPR
     changes, and remounts. */
  .background__canvas {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: block;
  }
`;
